import "./Footer.css";

export const Footer = () => {
  return (
    <div className="landingFooter" >
        <div className="landingFooterDropImage">
            <img src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/footer_drop.png"}/>
        </div>

        <div className="footerSections">
            <div className="footerSection">
                <div className="footerSectionHelp">
                    <div className="footerSectionTitle">
                    HELP
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="/faq">FAQ</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="https://fellowproducts.zendesk.com/hc/en-us/requests/new?ticket_form_id=360001567711">Get in Touch</a>
                       </div>
                    </div>
                </div>
            </div>

            <div className="footerSection">
                <div className="footerSectionAbout">
                    <div className="footerSectionTitle">
                    ABOUT
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="https://www.dropbox.com/sh/1tcsdnm7l6rmnnp/AAB6McGvbawBAE9EiQHPcJUKa?dl=0">Press Kit</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="/privacypolicy">Privacy Policy</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="/termsofuse">Terms of Use & Consent</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="https://fellowproducts.com/pages/our-commitment-to-accessibility">Accessibility Statement</a>
                       </div>
                    </div>
                </div>
            </div>

            <div className="footerSection footerSectionLast">
                <div className="footerSectionNeed">
                    <div className="footerSectionTitle">
                    NEED COFFEE GEAR?
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="https://fellowproducts.com/">Shop Fellow</a>
                       </div>
                    </div>
                </div>

                <div className="footerSectionFollow">
                    <div className="footerSectionTitle">
                    FOLLOW FELLOW
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="https://www.instagram.com/fellowproducts/?hl=en">Instagram</a>
                       </div>
                    </div>
                </div>

            </div>

        </div>



        <div className="footerSectionsMobile">
            <div className="footerSection">
                <div className="footerSectionHelp">
                    <div className="footerSectionTitle">
                    HELP
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="/faq">FAQ</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="https://fellowproducts.zendesk.com/hc/en-us/requests/new?ticket_form_id=360001567711">Get in Touch</a>
                       </div>
                    </div>
                </div>
                <div className="footerSectionAbout">
                    <div className="footerSectionTitle">
                    ABOUT
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="https://www.dropbox.com/sh/1tcsdnm7l6rmnnp/AAB6McGvbawBAE9EiQHPcJUKa?dl=0">Press Kit</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="/privacypolicy">Privacy Policy</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="/termsofuse">Terms of Use & Consent</a>
                       </div>
                       <div className="footerSectionLink">
                           <a href="https://fellowproducts.com/pages/our-commitment-to-accessibility">Accessibility Statement</a>
                       </div>
                    </div>
                </div>



            </div>

            <div className="footerSection footerSectionLast">
                <div className="footerSectionNeed">
                    <div className="footerSectionTitle">
                    NEED COFFEE GEAR?
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="https://fellowproducts.com/">Shop Fellow</a>
                       </div>
                    </div>
                </div>

                <div className="footerSectionFollow">
                    <div className="footerSectionTitle">
                    FOLLOW FELLOW
                    </div>
                    <div className="footerSectionBody">
                       <div className="footerSectionLink">
                           <a href="https://www.instagram.com/fellowproducts/?hl=en">Instagram</a>
                       </div>
                    </div>
                </div>

            </div>
        </div>


    </div>

  );
}
